import { updateEntity } from '../../../components/Common/Data/DataFetcherEntitiesHelper.js';
import { ENTITY_APPS } from '../../../Schema/Apps.js';

export const updateAppStatusInEntities = (app, newStatus) => (dispatch) => {
  dispatch(updateEntity(app, { status: newStatus }, ENTITY_APPS));
};
